/* eslint-disable import/no-default-export */
// @flow

import injectScript from './utils/injectScript';
import { getSocialNetwork } from './utils/getSocialNetwork';

import type { LoadPayload, WidgetParams } from './types';

const scripts = {
    // eslint-disable-next-line no-unused-vars
    pinterest(options: WidgetParams) {
        return getSocialNetwork.byName('PINTEREST').then(pinterestApp => {
            if (pinterestApp) {
                return injectScript('//assets.pinterest.com/sdk/sdk.js').then(() => {
                    return global.PDK;
                });
            }

            return null;
        });
    },

    facebook(options: WidgetParams) {
        const formattedLocale = options.locale.replace('-', '_'); // locale must be snake_case
        return getSocialNetwork.byName('FACEBOOK').then(fbApp => {
            if (fbApp) {
                return injectScript(`//connect.facebook.net/${formattedLocale}/sdk.js`, {
                    id: 'facebook-jssdk',
                }).then(() => {
                    global.FB.init({
                        appId: fbApp.parameters.clientId,
                        autoLogAppEvents: true,
                        xfbml: true,
                        version: 'v3.2',
                    });
                    global.FB.AppEvents.logPageView();

                    return global.FB;
                });
            }

            return null;
        });
    },

    google() {
        return getSocialNetwork.byName('GOOGLE').then(googleApp => {
            if (googleApp) {
                return injectScript('//apis.google.com/js/platform.js?onload=init').then(() => {
                    return new Promise(resolve => {
                        global.gapi.load('auth2', () => {
                            const GoogleAuth = global.gapi.auth2.init({
                                ['client_id']: googleApp.parameters.clientId,
                            });
                            GoogleAuth.then(resolve);
                        });
                    });
                });
            }
            return null;
        });
    },
};

// Getters are being used for Intercom, and everything related to them should be uncommented
// when Intercom is moved here
// const getters = {};

/**
 * Scripts loader. Also it caches loading promise to load script once.
 *
 * @param  {String} type script provider
 * @return {Promise}
 */
const load = function(type: LoadPayload, options: WidgetParams = { locale: 'en-US' }) {
    const loader = load[type];
    // const getter = getters[type];

    // if (loader && getter) {
    //     return loader.then(() => getter());
    // }
    if (loader) {
        return loader;
    }

    if (!scripts[type]) {
        throw new Error('Widget script for ' + type + ' is not provided.');
    }

    // In case scripts object has script as string:
    // load[type] = typeof scripts[type] === 'function' ?
    //     scripts[type]() :
    //     injectScript(scripts[type]);
    load[type] = scripts[type](options);

    return load[type];
};

const widgetLoader = { load };

export default widgetLoader;
